// BOT-484: one "confirmed" value on the item page. No source name, no tooltip (ticket).
// decision: freshness — see decisions/freshness.md
import type { FreshnessBand, FreshnessValue as Value } from '../../api/products';
import { fmtDayYear, fmtDaysAgo } from '../../utils/format';

const DOT: Record<FreshnessBand, string> = {
  green: 'bg-green-500',
  amber: 'bg-amber-500',
  red:   'bg-red-500',
  gray:  'bg-gray-300',
};

export function freshnessText(v: Value): string {
  if (v.state === 'never') return 'Never confirmed by Greenlight';
  if (v.state === 'no_source') return 'Not checked by Greenlight yet';
  // A confirmed value always carries both; if the API ever breaks that, say nothing rather than "today".
  if (v.confirmed_day == null || v.days_ago == null) return '—';
  return `${fmtDayYear(v.confirmed_day)} · ${fmtDaysAgo(v.days_ago)}`;
}

export default function FreshnessValue({ value }: { value: Value | null | undefined }) {
  if (!value) return <span>—</span>;
  return (
    <span className="flex flex-col leading-tight" data-testid="freshness-value">
      <span className="flex items-center gap-1.5">
        <span
          aria-hidden="true"
          data-testid="freshness-dot"
          data-band={value.band}
          className={`inline-block h-2 w-2 shrink-0 rounded-full ${DOT[value.band]}`}
        />
        <span>{freshnessText(value)}</span>
      </span>
      {value.pending_review && <span className="text-xs text-amber-700">Differs — in Review</span>}
    </span>
  );
}
